import { Controller } from '@hotwired/stimulus';

// Scrollspy for the account page: highlights the sidebar link and the mobile
// tab matching the section currently in view. Links/tabs carry data-anchor;
// each observed section is the element whose id equals that anchor.
export default class extends Controller {
  static targets = ['link', 'tab'];

  connect() {
    this.items = [...this.linkTargets, ...this.tabTargets];
    this.anchors = [...new Set(this.items.map((el) => el.dataset.anchor))];

    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      rootMargin: '-30% 0px -60% 0px',
    });

    this.anchors.forEach((anchor) => {
      const section = document.getElementById(anchor);
      if (section) this.observer.observe(section);
    });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      this.activate(entry.target.id);
    });
  }

  activate(anchor) {
    this.items.forEach((el) => {
      el.classList.toggle('is-active', el.dataset.anchor === anchor);
    });
  }
}
